<template>
  <div class="">
    <div class="contain">
      <div class="mbody">
          <div class='main'>
                <div class="pdbrow">
                    <div class="mtb5 fwbold">{{exams.paper_name}}</div>
                    <div class="flexrow f12 mt2">
                        <i class="el-icon-time"></i>
                        <div class="yellotext mr5">{{exams.startToEndTime}}</div>
                        <i class="el-icon-edit-outline"></i>
                        <div class='e5'>共</div>
                        <div class="yellotext">{{exams.subjectNum}}</div>
                        <div class='e5'>题</div>
                    </div>
                </div>
                <div class="pdbrow"  v-if="is_enter==0">
                    <div class="f12 fwbold">他们已报名...</div>
                    <div class="flexrow">
                        <img class='imgurl'  :key="item.user_id"
                            v-for="item in exams.participater_user_list"
                            :src="item.image_url">
                    </div>
                </div>
                <div class="pdbrow"  v-if="is_enter==2">
                    <div class="f12 fwbold">本次模考前6名</div>
                    <div class="flexrow">
                        <img class='imgurl'  :key="item.user_id"
                            v-for="item in exams.participater_rank_user_list"
                            :src="item.image_url">
                    </div>
                </div>

                <div class="f12 fwbold mtb10">配套解析课</div>
                <div class="corow" @click="VuegotoVideoCourse(exams.course_id)">
                    <div class="f14 fwbold">{{exams.course_name}}
                      <i class="el-icon-arrow-right"></i>
                    </div>

                    <div class="f12 e5 mt2">{{exams.desc}}</div>
                    <div class="flexrow f12 mt2">
                        <i class="el-icon-time"></i>
                        <div class="yellotext mr5">{{exams.play_time}}</div>
                        <i class="el-icon-bell"></i>
                        <div class="yellotext">{{exams.joinNum}}</div>
                        <div class='e5'>人报名</div>
                    </div>
                </div>

                <div class="time" v-if="dd!=0||hh!=0||mm!=0||ss!=0">
                    <div >距离开考</div>
                    <div class='tt'>{{dd}}</div>
                    <div >天</div>
                    <div class='tt'>{{hh}}</div>
                    <div >:</div>
                    <div class='tt'>{{mm}}</div>
                    <div >:</div>
                    <div class='tt'>{{ss}}</div>
                </div>
                <div class="time" v-if="dd==0||hh==0||mm==0||ss==0">
                    <div class="ml10">考试结束</div>
                </div>

                <div class="tcenter" v-if="is_enter==0">
                  <el-button v-if="exams.hasJoin!=1" class='subbtn' @click="VueSubmit">
                      立即报名
                  </el-button>
                  <el-button v-else class='yisubtn'>
                      已报名
                  </el-button>
                </div>

                <div class="tcenter"  v-if="is_enter==1">
                  <el-button class='subbtn' @click="VuegotoTestInfo">
                      进入考场
                  </el-button>
                </div>

                <div class="tcenter"  v-if="is_enter==2">
                  <el-button class='subbtn' @click="VuegotoTestResults">
                      查看报告
                  </el-button>
                </div>

                <div class="tcenter"  v-if="is_enter==3">
                  <el-button class='yisubtn'>
                      {{exams.reportTime.replace("T"," ")}}出报告
                  </el-button>
                </div>
          </div>



          <div class='mlab'>
              <div class=''>
              1.如何进入考场，考试当天可通过"必胜公考APP"或"必胜公考官网"进入考场。
              </div>
               <div class=''>
              2.开考前5分钟可提前进入查看题目，开考30分钟后不能再进入考场。
              </div>
              <div class=''>
              3.模考报告：考试结束后30分钟后，进入"必胜公考APP"可查看考试结果
              </div>
              <div class='mtb10'>
                开考期间如遇无法考试等情况可在"必胜公考APP"问答区中提问，客服人员将及时与您联系
              </div>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
import { api_drypractice_list } from "../../networks/DryRun"
import { api_submit_join } from "../../networks/DryRun"
import { api_server_time } from "../../networks/DryRun"


export default {
  name: 'HelloWorld',
  data () {
    return {
        exams:[],
        userid:'',
        dd:'0',
        hh:'0',
        mm:'0',
        ss:'0',
        is_enter:'0',
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created: function() {
      var context = this;
      var userid = context.user.user_id;
      //1.请求网络层
      var promise = api_drypractice_list(context,userid);
      //2.更新返回数据
      promise.then(function(data) {
          context.exams=data;

          context.GetServertime();

          //倒计时
          var str = data.startTime.replace(/-/g,"/");
          var time = str.replace('T', ' ');
          var EndTime = new Date(time);
          var NowTime = new Date();
          if (NowTime > EndTime) {
              return;
          }
          else{
              var interval = setInterval(function () {
                  context.GetRTime(time);

              }.bind(this), 1000);
          }

      }).catch(function(error){
      });
  },
   methods: {
      //============前往课程
      VuegotoVideoCourse(course_id) {
        this.$router.push({ name: 'Video', params: { course_id: course_id } })
      },
      //============立即报名
      VueSubmit() {
        var context = this;
        var userid = context.user.user_id;
        var paperId = context.exams.paperId;
        //1.请求网络层
        var promise = api_submit_join(context,userid,paperId);
        //2.更新返回数据
        promise.then(function(data) {
            if(data.data.code=='200'){
              context.$message({
                message: '报名成功',
                type: 'success'
              });
              context.exams.hasJoin= 1;
            }
            else{
               context.$message({
                  message: '报名失败',
                  type: 'warning'
                });
            }
        }).catch(function(error){
        });
      },
      //============获取模考服务器时间
      GetServertime() {
        var context = this;
        var userid = context.user.user_id;
        var paperId = context.exams.paperId;
        //1.请求网络层
        var promise = api_server_time(context,userid,paperId);
        //2.更新返回数据
        promise.then(function(data) {
            context.is_enter=data.data.result.is_enter;
        }).catch(function(error){
        });
      },
      //============前往 模考试卷
      VuegotoTestInfo(course_id) {
         var context = this;
         var paperId = context.exams.paperId;
         var paperName = context.exams.paperName;
         context.$router.push({ name: 'Exam', params: { paperId: paperId,paperName:paperName }});
      },
      //============前往 查看模考报告
      VuegotoTestResults() {
         var context = this;
         var paperId = context.exams.paperId;
         var paperName = context.exams.paperName;
         context.$router.push({ name: 'testresults', params: { paperId: paperId,paperName:paperName }});
      },
      //============倒计时
      GetRTime(endtime) {
        var context = this;
        var EndTime = new Date(endtime);
        var NowTime = new Date();
        var t = EndTime.getTime() - NowTime.getTime();

        if (t >= 0) {
            var t_dd = Math.floor(t / 1000 / 60 / 60 / 24);
            var t_hh = Math.floor(t / 1000 / 60 / 60 % 24);
            var t_mm = Math.floor(t / 1000 / 60 % 60);
            var t_ss = Math.floor(t / 1000 % 60);
        }
        context.dd=t_dd;
        context.hh=t_hh;
        context.mm=t_mm;
        context.ss=t_ss;
      },
    }
}
</script>

<style scoped>

.mbody{

    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

}

.main{
    width:28%;
    margin:10px auto;
    padding:15px 15px;
    border-radius:10px;
    border:1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    background-color: #fff;
}

.flexrow{
    display: flex;
    white-space:nowrap;
     align-items: center;
}

.f12{
font-size: 12px;
}
.f14{
font-size: 14px;
}
.fwbold{
font-weight:bold;

}


.imgurl{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin: 10px 10px 10px 0;
}

.pdbrow{
    padding: 10px 0;
    border-bottom: 1px solid #f5f5f5;
}
.mt2{
    margin-top: 2px;
}
.mr5{
    margin-right: 5px;
}

.mtb10{
  margin:10px 0;

}

.mtb5{
  margin:5px 0;
}

.yellotext{
    color: rgb(225,125,40);
}

.e5{
    color: rgb(181,181,181);
}
.corow{
    background-color:rgb(250,250,250);
    border-radius:17px;
    padding:12px;
    margin-bottom:10px;
}

.subbtn{
    height:38px;
    width:88%;
    font-size:15px;
    background-color:rgb(255,187,88);
    color: #fff;
}
.yisubtn{
    height:38px;
    width: 87%;
    font-size:15px;
    color: #606266;
}
.mlab{
    font-size:10px;
    color:#aaa;
    padding-left:5px;
       margin: 10px auto;
    width: 31%;

}

.icon{
    width:12px;
    height:12px;
  margin-right: 3px;
}

.time{
    width:87%;
    font-size: 14px;
    color: #606266;
    display: flex;
     align-items: center;
     justify-content: center;
     margin-bottom: 20px;
}

.tt{
    border:1px solid #e5e5e5;
    width:20px;
    margin: 0 10px;
     display: flex;
     align-items: center;
     justify-content: center;
}
.tcenter{
    text-align: center;
}
.ml10{
  margin-left:40px;
}
</style>



// WEBPACK FOOTER //
// src/components/DryRun/main.vue